<template>
    <div class="htc">
        <div class="page">
            <img class="logo" src="@/assets/logo.png" />
            <div class="snap">
                <div class="flexGrid">
                    <a-row type="flex" justify="space-around" align="middle" class="header p4">
                        <a-col>
                            <h1>Welcome HTC</h1>
                            <p>To get started, follow the steps below</p>
                        </a-col>
                    </a-row>
                
                    <a-row type="flex" justify="space-around" align="top" class="pt4 pl4 pr4 steps">
                        <a-col :span="24" :sm="8" class="mb4">
                            <i class="uil uil-import"></i>
                            <h2>1. Download</h2>
                            <p class="mb3">Download CVC HTC Vive build</p>
                           </a-col>
                        <a-col :span="24" :sm="8" class="mb4">
                            <i class="uil uil-caret-right"></i>
                            <h2>2. Run</h2>
                            <p>Unzip file & run CVCSim.exe</p>
                        </a-col>
                        <a-col :span="24" :sm="8" class="mb4">
                            <i class="uil uil-sign-in-alt"></i>
                            <h2>3. Login</h2>
                            <p class="mb3">Login with your credentials to continue</p>
                        </a-col>
                        <a-col :span="24" :md="18" :lg="12" :xl="8" class="mb4">
                            <div class="mb2">
                                <a-checkbox v-model="data_checked">I Agree to <a target="_blank" href="./legal/VantariVR-Privacy_Policy.pdf"><small>Privacy Policy</small></a>, <a target="_blank" href="./legal/VantariVR-Terms_of_Service.pdf"><small>Terms of Service</small></a> and the <a target="_blank" href="./legal/VantariVR-End_User_Licence_Agreement.pdf"><small>End-User License Agreement (EULA)</small></a></a-checkbox>
                            </div>
                            <a-button size="large" :disabled="!data_checked"  href="https://drive.google.com/u/0/uc?export=download&confirm=wWrY&id=1IFZTgNVlvr6pMIJ907uKzk9uhw0a7Q7n" target="_blank" download>Download</a-button>
                        </a-col>
                    </a-row>
                </div>            
            </div>
        </div>
        <div class="footer">
            <p class="text-white">11 York St, Sydney NSW 2000</p>
            <div class="icons">
                <i class="uil uil-facebook-f"></i>
                <i class="uil uil-twitter"></i>
                <i class="uil uil-linkedin"></i>
            </div>
            <img data-src="https://images.squarespace-cdn.com/content/v1/5be131302487fd7857a1449d/1541908704381-QI9Z7K924KYCUUHO3M7J/ke17ZwdGBToddI8pDm48kEdDCcDwdkhupQSziHND5jxZw-zPPgdn4jUwVcJE1ZvWEtT5uBSRWt4vQZAgTJucoTqqXjS3CfNDSuuf31e0tVEzBuhmHh9Pq1AK2_53jvhtU25lRJsc5M-Hzn1_UAFStCb8BodarTVrzIWCp72ioWw/VantariVR+Logo" data-image="https://images.squarespace-cdn.com/content/v1/5be131302487fd7857a1449d/1541908704381-QI9Z7K924KYCUUHO3M7J/ke17ZwdGBToddI8pDm48kEdDCcDwdkhupQSziHND5jxZw-zPPgdn4jUwVcJE1ZvWEtT5uBSRWt4vQZAgTJucoTqqXjS3CfNDSuuf31e0tVEzBuhmHh9Pq1AK2_53jvhtU25lRJsc5M-Hzn1_UAFStCb8BodarTVrzIWCp72ioWw/VantariVR+Logo" data-image-dimensions="348x329" data-image-focal-point="0.5,0.5" data-load="false" data-image-id="5be7a8e0f950b7767090ce7f" data-type="image" alt="VantariVR Logo" data-image-resolution="300w" src="https://images.squarespace-cdn.com/content/v1/5be131302487fd7857a1449d/1541908704381-QI9Z7K924KYCUUHO3M7J/ke17ZwdGBToddI8pDm48kEdDCcDwdkhupQSziHND5jxZw-zPPgdn4jUwVcJE1ZvWEtT5uBSRWt4vQZAgTJucoTqqXjS3CfNDSuuf31e0tVEzBuhmHh9Pq1AK2_53jvhtU25lRJsc5M-Hzn1_UAFStCb8BodarTVrzIWCp72ioWw/VantariVR+Logo?format=300w">
            <div><a target="_blank" href="https://www.vantarivr.com">www.vantarivr.com</a></div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Home',
    data() {
        return {
            data_checked: false
        }
    }
}
</script>

<style lang="less">
.htc {
    .page {
    position: relative;
    height: 100vh;
    background: #000;
    background-position: center;
    background-size: cover;
    background-image: url('/purple_guy.png');
}
 .logo {
        position: absolute;
        top:0;
        left:0;
        margin: 40px;
    }
.snap {
    text-align: left;
    position: absolute;
    bottom: 0;
    width: 100%;
}
.flexGrid {
    height: 100vh;
    display: flex;
    flex-direction: column;
}
.header {
 color:#fff;
 text-align: center;
 height: 100%;
  h1 {
        font-size: 48px;
        font-weight: bold;
        margin-bottom: 0px;
    }
    p {
       
        font-size: 24px;
    }
}
.steps {
    background-color: #fff;
    text-align: center;
    .ant-checkbox-wrapper {
        display: block;
    }
    .ant-checkbox-inner {
        border-color: rgba(0,0,0,0.3);
    }
    a {
        font-size: 18px;
        border-color: rgba(0,0,0,0.3)
    }
    h2 {
        margin-top: 40px;
    }
    i {
        background: rgba(0,0,0,0.1);
        color: rgba(0,0,0,0.7);
        padding: 20px;
        border-radius: 50%;
        font-size: 48px;
    }
}
.footer {
    text-align: center;
    padding: 48px;
    font-size: 20px;
    color: rgba(255,255,255,.72);
    background-color: #0d375e;
    a {
        color: #fff;
    }
    p {
        padding-top: 20px;
    }
    .icons {
        padding: 17px;
    }
    i {
        color: #fff;
        font-size: 28px;
    }
    img {
        margin-top: 28px;
        width: 115px;
        margin-bottom: 100px;
    }
}
}

</style>